// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /*Titlebar*/
    --topbarColor: var(--DarkBlue);
    --topbarSelectorColor: var(--HighlightBlue);
    --TopBarHeaderTitle: white;

    /*Selector*/
    --sidbarColor: var(--LiterGrayBlue);
    --sidbarSelectorColor: var(--GrayBlue);

    /*Middle content*/
    --middelColor: var(--GrayBlue);
    --maxMiddelContainerWidth: 1500px;

    /* filter page colors*/
    --filterColorTopBar: var(--DarkBlue);
    --filterColorElse: var(--GrayBlue);
    --filterColorChanged: var(--DarkBlue);
    --filterColorSuccess: var(--HighlightBlue);
    --filterColorError: var(--Gray);
    --filterColorMiddleContainer: var(--Gray);

    /*Settings page colors*/
    --settingsColorBackgroundContainer: var(--DarkBlue);
    --settingsTextColor: var(--Gray);
    --settingsTextColor2: var(--HighlightBlue);

    /*Templates page colors*/
    --templatesColorBackgroundContainerRemoved: var(--LiterGrayBlue);
    --templatesColorBackgroundContainer: var(--DarkBlue);
    --templatesColorBackgroundInContainer: var(--GrayBlue);
    --templatesColorTextInContainer: var(--LiterGrayBlue);
    --templatesColorHeiglight: var(--HighlightBlue);
}
`, "",{"version":3,"sources":["webpack://./src/style/page.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,2CAA2C;IAC3C,0BAA0B;;IAE1B,WAAW;IACX,mCAAmC;IACnC,sCAAsC;;IAEtC,iBAAiB;IACjB,8BAA8B;IAC9B,iCAAiC;;IAEjC,sBAAsB;IACtB,oCAAoC;IACpC,kCAAkC;IAClC,qCAAqC;IACrC,0CAA0C;IAC1C,+BAA+B;IAC/B,yCAAyC;;IAEzC,uBAAuB;IACvB,mDAAmD;IACnD,gCAAgC;IAChC,0CAA0C;;IAE1C,wBAAwB;IACxB,gEAAgE;IAChE,oDAAoD;IACpD,sDAAsD;IACtD,qDAAqD;IACrD,+CAA+C;AACnD","sourcesContent":[":root {\n    /*Titlebar*/\n    --topbarColor: var(--DarkBlue);\n    --topbarSelectorColor: var(--HighlightBlue);\n    --TopBarHeaderTitle: white;\n\n    /*Selector*/\n    --sidbarColor: var(--LiterGrayBlue);\n    --sidbarSelectorColor: var(--GrayBlue);\n\n    /*Middle content*/\n    --middelColor: var(--GrayBlue);\n    --maxMiddelContainerWidth: 1500px;\n\n    /* filter page colors*/\n    --filterColorTopBar: var(--DarkBlue);\n    --filterColorElse: var(--GrayBlue);\n    --filterColorChanged: var(--DarkBlue);\n    --filterColorSuccess: var(--HighlightBlue);\n    --filterColorError: var(--Gray);\n    --filterColorMiddleContainer: var(--Gray);\n\n    /*Settings page colors*/\n    --settingsColorBackgroundContainer: var(--DarkBlue);\n    --settingsTextColor: var(--Gray);\n    --settingsTextColor2: var(--HighlightBlue);\n\n    /*Templates page colors*/\n    --templatesColorBackgroundContainerRemoved: var(--LiterGrayBlue);\n    --templatesColorBackgroundContainer: var(--DarkBlue);\n    --templatesColorBackgroundInContainer: var(--GrayBlue);\n    --templatesColorTextInContainer: var(--LiterGrayBlue);\n    --templatesColorHeiglight: var(--HighlightBlue);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
